import { StandardEvents } from '@shopify/events';
const updateCount = (count) => {
  if (!Number.isFinite(count)) return;
  document.querySelectorAll('.lv-bag').forEach((bag) => {
    bag.querySelector('span').textContent = String(count);
    bag.setAttribute('aria-label', `${bag.dataset.cartLabel} (${count})`);
  });
};
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    updateCount(cart?.totalQuantity ?? detail?.itemCount);
  }).catch(() => {});
});
window.addEventListener('pageshow', (event) => {
  const bag = document.querySelector('.lv-bag');
  if (event.persisted && bag) {
    fetch(`${bag.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => cart && updateCount(cart.item_count)).catch(() => {});
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.lv-menu[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.lv-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
